import styles from './adminNps.module.scss';
import {Table, Spin} from 'antd';
import {Button} from '@dabafinance/react-components';
import {Outlet, Route, Routes, useNavigate} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import pageNotFound from 'images/pageNotFound.png';
import moment from 'moment';
import {GET_ALL_NET_PROMOTER} from 'graphql/queries/nps';
import gamer from 'images/gamer.png';
import {CustomLink} from 'components/investorUpdate/management';
import {CustomerReviews} from './CustomerReviews';
import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';
import UserLink from 'components/userLink/UserLink';

const NPS_SUBTABS = [
  {key: 'nps', to: '/dashboard/customers/nps', name: 'Net Promoter'},
  {
    key: 'reviews',
    to: '/dashboard/customers/reviews',
    name: 'Customer Feedback',
  },
];

const CustomerFeedbackHeader = () => {
  const {visibleSubTabs} = useVisibleSubTabs(NavTabsEnum.UsersNPS, NPS_SUBTABS);

  return (
    <div>
      <div className={styles.routers}>
        {visibleSubTabs.map(tab => (
          <CustomLink key={tab.key} to={tab.to} name={tab.name} />
        ))}
      </div>
      <section>
        <Outlet />
      </section>
    </div>
  );
};

export const CustomerFeedBackRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<CustomerFeedbackHeader />}>
        <Route index path="/nps" element={<NetPromoter />} />
        <Route path="/reviews" element={<CustomerReviews />} />
      </Route>
    </Routes>
  );
};

const NetPromoter = () => {
  const navigate = useNavigate();

  const {data, loading} = useQuery(GET_ALL_NET_PROMOTER);

  const columns = [
    {
      title: 'Full Name',
      dataIndex: 'firstName',
      key: 'firstName',
      render: (text, record) => (
        <div className={styles['record-label']}>
          <div className={styles['record-name']}>
            {record?.user?.imageUrl ? (
              <img src={record?.user?.imageUrl} alt="" />
            ) : (
              <img src={gamer} alt="" />
            )}
            <h4>
              <UserLink userId={record?.user?.id}>
                {record?.user?.firstName} {record?.user?.lastName}
              </UserLink>
            </h4>
          </div>
        </div>
      ),
    },
    {
      title: 'Score',
      dataIndex: 'recommendationScore',
      key: 'recommendationScore',
      render: (text, record) => (
        <div>
          <span>{record?.recommendationScore}</span>
        </div>
      ),
    },
    {
      title: 'Feedback',
      dataIndex: 'feedback',
      key: 'feedback',
      render: (text, record) => (
        <div>
          <span>{record?.feedback}</span>
        </div>
      ),
    },
    {
      title: 'Creation Date',
      dataIndex: 'createdAt',
      key: 'creationdate',
      render: (text, record) => (
        <span>{moment(record?.createdAt).format('DD MMMM YYYY')}</span>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'operation',
      key: 'actions',
      render: (text, record) => (
        <div>
          <Button
            onClick={() => navigate(`/dashboard/nps/${record?.user?.id}`)}
            type="secondary"
            label="View Details"
            className={styles['deactivate-btn']}
          />
        </div>
      ),
    },
  ];

  if (loading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <div className={styles['container-wrapper']}>
      <h1>Net Promoter Scores</h1>
      <div className={styles['startup-table']}>
        <div className={styles['startup-header']}></div>
        <div className={styles['table-height']}>
          {data?.getAllNetPromoterScores?.length >= 1 ? (
            <div>
              <Table
                columns={columns}
                dataSource={data?.getAllNetPromoterScores}
              />
            </div>
          ) : (
            <div className={styles['no-update']}>
              <img src={pageNotFound} alt="" />
              <h1>No Net Promoter Score found</h1>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NetPromoter;
